import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BorderedDiv, TBorderedDivProps } from 'elements/layout/BorderedDiv'
import { Cell } from 'elements/layout/Cell'
import { Div } from 'elements/layout/Div'
import { Li } from 'elements/layout/Li'
import { Row } from 'elements/layout/Row'
import { Span } from 'elements/layout/Span'
import { Ul } from 'elements/layout/Ul'
import { Icon } from 'elements/media/Icon'
import { Link } from 'elements/text/Link'
import { Text } from 'elements/text/Text'

import { ICON } from 'config/icons'
import theme from 'config/theme'

import type { TGuideMenuDesktopProps } from './GuideMenuDesktop'

type TGuideMenuMobileProps = TGuideMenuDesktopProps & TBorderedDivProps

export const GuideMenuMobile: TFC<TGuideMenuMobileProps> = ({ titles, ...otherDivProps }) => {
  const [isExpanded, setExpanded] = useState(false)
  const { t } = useTranslation()

  return (
    <Div
      as="nav"
      role="navigation"
      position="relative"
      aria-label={t('guide:word.menu')}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      {...otherDivProps}
    >
      <BorderedDiv
        borderRadius="4px"
        borderColor="blue"
        p="0 10px"
        onClick={() => setExpanded(!isExpanded)}
        id="Summary__button"
        w="100%"
      >
        <Row align="middleLeft">
          <Cell flex="1" align="middleBetween">
            <Text color="darkBlue" fontSize="1em" lineHeight="2.5em">
              trans:guide:word.menu
            </Text>
            <Span right>
              <Icon name={isExpanded ? ICON.CHEVRON_UP : ICON.CHEVRON_DOWN} m="0 0 0 10px" color="blue" />
            </Span>
          </Cell>
        </Row>
      </BorderedDiv>
      <Ul
        style={isExpanded ? { height: '100%', overflow: 'auto' } : { height: '0px', overflow: 'hidden' }}
        m="1em 0 0"
        p="0 10px"
        id="Summary__content"
      >
        {titles.map((title, i) => (
          <Li key={i} style={{ textAlign: 'left' }} m={titles.length === i + 1 ? '0' : '0 0 20px'}>
            <Link
              to={`#${title.id}`}
              color="darkBlue"
              style={{
                display: 'block',
                fontSize: '1em',
                lineHeight: '1.4em',
                fontFamily: theme.fontFamily['openSans'],
                outlineStyle: 'none',
              }}
              w="100%"
            >
              {title.textContent}
            </Link>
          </Li>
        ))}
      </Ul>
    </Div>
  )
}
